import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Header = ({ title, subtitle, userName, userAvatar, userRole, breadcrumb, onSidebarToggle }) => {
  const [avatarImageError, setAvatarImageError] = useState(false);
  const navigate = useNavigate();
  
  // Get initials from userName (e.g., "Landlord Twoone" -> "LT")
  const getInitials = (name) => {
    if (!name) return 'U';
    const parts = name.trim().split(' ').filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  // Get first name for greeting (e.g., "Landlord Twoone" -> "Landlord")
  const getFirstName = (name) => {
    if (!name) return '';
    const parts = name.trim().split(' ').filter(Boolean);
    return parts[0] || '';
  };

  const handleAvatarImageError = () => {
    setAvatarImageError(true);
  };

  const firstName = getFirstName(userName);

  return (
    <header className="header">
      {onSidebarToggle && (
        <button
          type="button"
          className="header-sidebar-toggle"
          aria-label="Open menu"
          onClick={onSidebarToggle}
        >
          <span className="header-sidebar-toggle-bar" />
          <span className="header-sidebar-toggle-bar" />
          <span className="header-sidebar-toggle-bar" />
        </button>
      )}
      <div className="header-left">
        {breadcrumb ? (
          <div className="header-breadcrumb">
            {breadcrumb.map((item, index) => (
              <React.Fragment key={index}>
                {index > 0 && <span className="header-breadcrumb-separator"> &gt; </span>}
                {item.path ? (
                  <span 
                    className="header-breadcrumb-link"
                    onClick={() => navigate(item.path)}
                  >
                    {item.label}
                  </span>
                ) : (
                  <span className="header-breadcrumb-current">{item.label}</span>
                )}
              </React.Fragment>
            ))}
          </div>
        ) : (
          title && <h1 className="header-title">{title}</h1>
        )}
      </div>
      <div className="header-user">
        <div className="header-user-text">
          <span className="header-greeting">👋 Hello {firstName || userName}!</span>
          {userRole && (
            <span className="header-role-label">
              {userRole}
            </span>
          )}
        </div>
        <div className="header-avatar">
          {avatarImageError || !userAvatar ? (
            <div className="header-avatar-placeholder">
              {getInitials(userName)}
            </div>
          ) : (
            <img 
              src={userAvatar} 
              alt={userName}
              onError={handleAvatarImageError}
            />
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
